import { useState, useEffect, useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { Skeleton } from "antd";
import Tree, { DataNode } from "antd/es/tree";
import { motion } from "framer-motion";
import { env } from "@/shared/config";
import { projectQueries } from "@entities/project";
import "./navigation-contracts.scss";

export const NavigationContracts = ({
  collapsed,
  integrationId,
}: {
  collapsed: boolean;
  integrationId: string;
}) => {
  const { data, isLoading } = useQuery({
    ...projectQueries.getProjectContracts({ projectId: integrationId }),
  });
  const [treeData, setTreeData] = useState<DataNode[]>([]);

  const configureTreeData = useCallback((nodes: any[] | undefined): DataNode[] => {
    if (!nodes) return [];
    return nodes.map((node) => ({
      key: node.self.journalId,
      // title теперь <a>
      title: (
        <a
          className="navigation-contracts-link"
          href={`${env.OLD_FRONTEND_URL}/projects/${integrationId}/contracts/${node.self.journalId}/requisites`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {node.self.title}
        </a>
      ),
      children: node.children ? configureTreeData(node.children) : undefined,
    }));
  }, [integrationId]);

  useEffect(() => {
    if (data?.journalNodes) {
      setTreeData(configureTreeData(data.journalNodes));
    }
  }, [configureTreeData, data]);

  if (isLoading) {
    return (
      <div className="navigation-contracts-loading">
        <Skeleton.Node style={{ width: "200px", height: "20px" }} active />
      </div>
    );
  }

  return (
    <motion.div
      className="navigation-contracts-block"
      animate={{
        opacity: collapsed ? 0 : 1,
      }}
      transition={{ duration: 0.5 }}
    >
      <div className="navigation-contracts-header">
        <p className="navigation-contracts-label">ДОГОВОРЫ</p>

        {/* {collapsed ? null : (
          <a
            href={`${env.OLD_FRONTEND_URL}/projects/${integrationId}/contracts/create`}
            target="_blank"
            onClick={() => {
              const code = window.prompt("Для перехода введите код подтверждения:");
              if (code !== "1313132018") {
                event.preventDefault();
                return;
              }
            }}
            rel="noopener noreferrer"
            style={{
              color: "#0034AD",
              fontWeight: 400,
              fontSize: "10.5px",
              cursor: "pointer",
              textDecoration: "none",
            }}
          >
            [ + ]
          </a>
        )} */}
      </div>
      <Tree
        className="contracts-tree"
        treeData={treeData}
        rootClassName="contracts-tree-root"
        defaultExpandAll={false}
        showLine={false}
      />
    </motion.div>
  );
};
